import React from 'react'
import PropTypes from 'prop-types'
import { Container, Columns, Column, Steps } from '@resurs/midas-react'
import { PageModel } from '../models/private-models'
import PayApplyApplicationInfoUI from '../UI/PayApplyApplicationInfoUI'

const setActiveStep = (steps, activeStep) => {
  const stepsWithActive = []
  steps.map((step, index) => {
    if (index === activeStep) {
      stepsWithActive.push({ active: true, ...step })
    } else {
      stepsWithActive.push(step)
    }
    return stepsWithActive
  })
  return stepsWithActive
}

const Wizard = ({ steps, activeStep, currentPage, children, data }) => {
  return (
    <div style={{ marginTop: '1rem' }}>
      <Container grid960>
        <Columns>
          <Column col12>
            <Steps values={setActiveStep(steps, activeStep)} />
          </Column>
        </Columns>
      </Container>

      {(currentPage === PageModel.PAYMENT_METHOD && !data.paymentMethods) ||
        (currentPage !== PageModel.GOVERNMENT_ID &&
          currentPage !== PageModel.APPLICATION_DONE &&
          currentPage !== PageModel.ERROR &&
          currentPage !== PageModel.APPLICATION_REJECTED && (
            <PayApplyApplicationInfoUI data={data} />
          ))}

      <Container grid960>{children}</Container>
    </div>
  )
}

Wizard.propTypes = {
  children: PropTypes.object,
  data: PropTypes.object.isRequired,
  steps: PropTypes.array.isRequired,
  activeStep: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
}

Wizard.defaultProps = {
  children: null,
}

export default Wizard
